import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import './icons' // icon
import './errorLog'// error log
import './permission' // permission control
import './mock' // simulation data

import * as filters from './filters' // global filters

import Sticky from '@/components/Sticky'
import permission from '@/directive/permission/index.js' // 权限判断指令

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import * as Sentry from '@sentry/vue';
import { Integrations } from "@sentry/tracing";
import dataV from '@jiaminghi/data-view'

import jsonExcel from 'vue-json-excel'

// import '@/assets/icons'

Vue.component('Sticky', Sticky)
Vue.component('downloadExcel', jsonExcel)
Vue.directive('perm', permission)
Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999
	}
})
Vue.use(dataV)
Vue.use(Element, {
	size: 'mini'//, // set element-ui default size
	//i18n: (key, value) => i18n.t(key, value)
})

// Sentry.init({
// 	    Vue,
// 	    dsn: process.env.SENTRY_DSN,
// 	    autoSessionTracking: true,
// 	    integrations: [
// 	      new Integrations.BrowserTracing(),
// 	    ],
// 	  
// 	    // We recommend adjusting this value in production, or using tracesSampler
// 	    // for finer control
// 	    tracesSampleRate: 1.0,
// });

Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

Vue.config.productionTip = false


//字符串处理
String.prototype.trimChar = function (char, type) {
	if (char) {
		if (type == 'left') {
			return this.replace(new RegExp('^\\' + char + '+', 'g'), '');
		} else if (type == 'right') {
			return this.replace(new RegExp('\\' + char + '+$', 'g'), '');
		}
		return this.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
	}
	return this.replace(/^\s+|\s+$/g, '');
};
String.prototype.trim = function () {
	return this.replace(/(^\s*)|(\s*$)/g, "");
}
String.prototype.ltrim = function () {
	return this.replace(/(^\s*)/g, "");
}
String.prototype.rtrim = function () {
	return this.replace(/(\s*$)/g, "");
}
String.prototype.endWith = function (str) {
	if (str == null || str == "" || this.length == 0 || str.length > this.length)
		return false;
	if (this.substring(this.length - str.length) == str)
		return true;
	else
		return false;
	return true;
}
String.prototype.startWith = function (str) {
	if (str == null || str == "" || this.length == 0 || str.length > this.length)
		return false;
	if (this.substr(0, str.length) == str)
		return true;
	else
		return false;
	return true;
}

const capitalize = ([first, ...rest], lowerRest = false) =>
	first.toUpperCase() + (lowerRest ? rest.join('').toLowerCase() : rest.join(''));

//将oracle数据库字段名转为属性名格式
function convertColName(colname) {
	let parts = colname.split("_");
	var sb = "";
	sb += parts[0].toLowerCase();
	if (parts.length >= 2) {
		for (var j = 1; j < parts.length; j++) {
			sb += capitalize(parts[j].toLowerCase());
		}
	}

	return sb;
}
//转驼峰风格字段名（java对象属性名风格）
window.toCamelCase = function (obj) {
	if (!obj)
		return obj

	if (Array.isArray(obj)) {
		return obj.map(v => toCamelCase(v))
	} else {
		let ret = new Object()
		Object.keys(obj).forEach(function (key) {
			ret[convertColName(key)] = obj[key]
		});
		return ret
	}

}

//将oracle数据库字段名转为属性名格式
function convertFieldName(fieldName) {
	return fieldName.replace(/([A-Z])/g, "_$1").toLowerCase();
}

//转下划线风格字段名（oracle字段名风格）
window.toFieldCase = function (obj) {
	if (!obj)
		return obj

	if (Array.isArray(obj)) {
		return obj.map(v => toFieldCase(v))
	} else {
		let ret = new Object()
		Object.keys(obj).forEach(function (key) {
			ret[convertFieldName(key)] = obj[key]
		});
		return ret
	}

}


//获得供暖年度，输入月日作为界限
window.hotyear_split_month = 7
window.hotyear_split_day = 15
window.get_hotyear = function () {
	let now = new Date()
	let splitDay = new Date(now.getFullYear(), hotyear_split_month - 1, window.hotyear_split_day)
	if (now >= splitDay) {
		return now.getFullYear()
	} else {
		return (now.getFullYear() - 1)
	}
}
window.get_hotyear_begin_date = function () {
	let year = window.get_hotyear()
	//// new Date(year,hotyear_split_month,window.hotyear_split_day))
	return new Date(year, hotyear_split_month - 1, window.hotyear_split_day)
}
window.get_hotyear_end_date = function () {
	let year = window.get_hotyear()
	//// new Date((year+1),hotyear_split_month,window.hotyear_split_day))
	return new Date((year + 1), hotyear_split_month - 1, window.hotyear_split_day)
}


window.getRootPath = function getRootPath() {
	//获取当前网址，如： http://localhost:8083/uimcardprj/share/meun.jsp
	var curWwwPath = window.document.location.href;
	//获取主机地址之后的目录，如： uimcardprj/share/meun.jsp
	var pathName = window.document.location.pathname;
	var pos = curWwwPath.indexOf(pathName);
	//获取主机地址，如： http://localhost:8083
	var localhostPaht = curWwwPath.substring(0, pos);
	//获取带"/"的项目名，如：/uimcardprj
	var projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
	return (localhostPaht + projectName);
}

window.getCurrentMonthFirst = function getCurrentMonthFirst() {
	var date = new Date();
	date.setDate(1);
	var month = parseInt(date.getMonth() + 1);
	var day = date.getDate();
	if (month < 10) {
		month = '0' + month
	}
	if (day < 10) {
		day = '0' + day
	}
	return date.getFullYear() + '-' + month + '-' + day;
}

window.getCurrentMonthLast = function getCurrentMonthLast() {
	var date = new Date();
	var currentMonth = date.getMonth();
	var nextMonth = ++currentMonth;
	var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
	var oneDay = 1000 * 60 * 60 * 24;
	var lastTime = new Date(nextMonthFirstDay - oneDay);
	var month = parseInt(lastTime.getMonth() + 1);
	var day = lastTime.getDate();
	if (month < 10) {
		month = '0' + month
	}
	if (day < 10) {
		day = '0' + day
	}

	return date.getFullYear() + '-' + month + '-' + day;
}


window.api_url = process.env.BASE_API;






Vue.prototype.hasPerm = function (permArray) {
	const roles = store.getters && store.getters.roles
	if (permArray && permArray instanceof Array && permArray.length > 0) {
		const hasPermission = roles.some(role => {
			return permArray.includes(role.name)
		})
		return hasPermission
	} else {
		//"hasPerm 参数错误")
		return false
	}
}

Array.prototype.getItem = function (keyFieldName, keyFieldValue) {
	return this.find(item => item[keyFieldName] == keyFieldValue)
}

window.isRealNum = function (val) {
	if (typeof val !== 'number') {
		return false;
	}
	if (!isNaN(val)) {
		return true;
	} else {
		return false;
	}
}


window.dateFormat = function (fmt, date) {
	let ret;
	const opt = {
		"Y+": date.getFullYear().toString(),        // 年
		"m+": (date.getMonth() + 1).toString(),     // 月
		"d+": date.getDate().toString(),            // 日
		"H+": date.getHours().toString(),           // 时
		"M+": date.getMinutes().toString(),         // 分
		"S+": date.getSeconds().toString()          // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		};
	};
	return fmt;
}

// 阻止按键，esc，tab,tnter

window.strToDate = function (dateStr) {
	var date = dateStr;
	date = date.replace(/-/g, '/');
	return new Date(date)
}
var appVm = new Vue({
	el: '#app',
	router,
	store,
	//i18n,
	template: '<App/>',
	components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js